export enum NumberFieldFormat {
  Percentage = "Percentage",
  Currency = "Currency",
  Number = "Number"
}
